import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { watchScrollbars } from "@/ui";
import { App } from "./App";

watchScrollbars();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
